// extracted by mini-css-extract-plugin
export var active = "Menu-module--active--XLQcK";
export var borderBottom = "Menu-module--borderBottom--Qm7zy";
export var link = "Menu-module--link--gQW0c";
export var linkWrapper = "Menu-module--linkWrapper--u5eMn";
export var menuContainer = "Menu-module--menuContainer--Hnp7P";